import { render, staticRenderFns } from "./review-card-lite.vue?vue&type=template&id=6531df6c"
import script from "./review-card-lite.vue?vue&type=script&lang=ts"
export * from "./review-card-lite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports